import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ResourceAccount } from '../shared/models/generated/ziroModels';

@Injectable({ providedIn: 'root' })
export class ResourceAccountsResource {
  private _http = inject(HttpClient);

  getResourceAccount(tenantId: string, upn: string): Observable<ResourceAccount> {
    return this._http.get<ResourceAccount>(
      `/services/microsoft/resource-account-management/tenants/${tenantId}/resource-accounts/${encodeURIComponent(upn)}`,
    );
  }

  createResourceAccount(tenantId: string, resourceAccount: ResourceAccount): Observable<void> {
    return this._http.post<void>(
      `/services/microsoft/resource-account-management/tenants/${tenantId}/resource-accounts`,
      resourceAccount,
    );
  }

  updateResourceAccount(tenantId: string, upn: string, resourceAccount: ResourceAccount): Observable<void> {
    return this._http.put<void>(
      `/services/microsoft/resource-account-management/tenants/${tenantId}/resource-accounts/${upn}`,
      resourceAccount,
    );
  }

  deleteResourceAccount(tenantId: string, upn: string): Observable<void> {
    return this._http.delete<void>(
      `/services/microsoft/resource-account-management/tenants/${tenantId}/resource-accounts/${upn}`,
    );
  }
}
